<div class="registration-form">
  <form class="loginform">
    <!-- <img class="icon icon-user" src="assets/images/recycle.png"> -->
    <div class="header">
      <p class="title">{{publicservice.Texts.Texts['signin1']}}</p>
    </div>

    <div style="direction: rtl;">
      <mat-form-field class="form-group" appearance="legacy">
        <mat-label class="label">{{publicservice.Texts.Texts["signin2"]}}
        </mat-label>
        <input matInput [formControl]="namesignin" type="text" class="item" id="name" type="text"
               [(ngModel)]="publicservice.name">
        <mat-error *ngIf="namesignin.hasError('required')" class="error">
          {{publicservice.Texts.Texts["signin4"]}}
          <!-- <strong>{{publicservice.Texts.Texts["login3"]}}</strong>
      {{publicservice.Texts.Texts["logi3"]}} -->
        </mat-error>

      </mat-form-field>
    </div>

    <mat-form-field class="form-group-email" appearance="legacy">
      <mat-label class="label">{{publicservice.Texts.Texts["signin3"]}}
      </mat-label>
      <input matInput [formControl]="emailsignin" type="text" class="item" id="email" type="text"
             [(ngModel)]="publicservice.email">
      <mat-error *ngIf="emailsignin.hasError('email')" class="error">
        <p class="text-break"> {{publicservice.Texts.Texts["signin5"]}}</p>
      </mat-error>
    </mat-form-field>
    <div style="display: grid; ">
      <p [class]="key" style="font-family: iransans;color: #ff5656;float: right;text-align: right;margin-top: -20px;">
        این ایمیل قبلا با
        شماره موبایل دیگری به ثبت رسیده است. لطفا ایمیل دیگری وارد کنید</p>

      <div style="justify-content: center;text-align: center;">
        <!-- <div style="display: flex; justify-content: space-around;"> -->
        <!-- <div class="form-group-btn">
          <button mat-button type="submit" class="btn btn-block create-account2" (click)="signin()">
              اعمال
          </button>
      </div> -->

        <mat-form-field class="form-group-code" appearance="outline">
          <mat-label class="label">کد معرف
          </mat-label>
          <input matInput type="text" class="item2" id="email" [ngModelOptions]="{standalone: true}"
                 [(ngModel)]="publicservice.inv_code">
          <mat-error *ngIf="emailsignin.hasError('email')" class="error">
            <p class="text-break"> {{publicservice.Texts.Texts["signin5"]}}</p>
          </mat-error>
        </mat-form-field>

      </div>
      <p [class]="keyInv" style="font-family: iransans;color: #ff5656;text-align: center;">
        کد معرف صحیح نمی باشد
      </p>
    </div>

    <div class="form-group-btn">
      <button mat-button type="submit" class="btn btn-block create-account" (click)="signin()">
        {{publicservice.Texts.Texts['login3']}}
      </button>
    </div>
  </form>
  <mat-spinner id="loading" *ngIf="loading"></mat-spinner>

  <div class="footer">
    <div style="display: flex;text-align: center;justify-content: center;">
      <p style="font-weight: bold;padding-right: 5px;"><a href="https://karinco.ir" style="color: #000;">کارین</a></p>
      <p> طراحی و پیاده سازی توسط شرکت</p>
    </div>
  </div>

</div>
<!-- <script type="text/javascript" src="https://code.jquery.com/jquery-3.2.1.min.js"></script>
    <script type="text/javascript" src="https://cdnjs.cloudflare.com/ajax/libs/jquery.mask/1.14.15/jquery.mask.min.js"></script>
    <script src="assets/js/script.js"></script>
 -->
